import React, { useState, useEffect } from "react";
import { SearchIcon } from "@heroicons/react/outline";
import styled from "styled-components";
import { Theme } from "../../atoms/theme";

const SearchContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  background: ${Theme.colors.neutrals_500};
  border-bottom: 1px solid ${Theme.colors.neutrals_400};
`;

const SearchInput = styled.input`
  flex: 1;
  max-width: 28rem;
  height: 3rem;
  padding: 0.5rem 1rem;
  border: 1px solid ${Theme.colors.neutrals_400};
  border-radius: ${Theme.radii.corner_radius_s};
  background: ${Theme.colors.neutrals_500};
  color: ${Theme.colors.neutrals_100};
  font-size: 0.875rem;

  &:focus {
    outline: none;
    border-color: ${Theme.colors.primaries_000};
  }

  &::placeholder {
    color: ${Theme.colors.neutrals_200};
  }
`;

const SearchIconWrapper = styled.div`
  color: ${Theme.colors.neutrals_200};
`;

interface SearchBarProps {
  value?: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

export const SearchBar: React.FC<SearchBarProps> = ({
  value = "",
  onChange,
  placeholder = "Search",
}) => {
  const [searchValue, setSearchValue] = useState(value);

  useEffect(() => {
    setSearchValue(value);
  }, [value]);

  // Debounce the search
  useEffect(() => {
    const timer = setTimeout(() => {
      onChange(searchValue);
    }, 300);

    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchValue]);

  return (
    <SearchContainer>
      <SearchIconWrapper>
        <SearchIcon className="h-5 w-5" />
      </SearchIconWrapper>
      <SearchInput
        type="text"
        value={searchValue}
        onChange={(e) => setSearchValue(e.target.value)}
        placeholder={placeholder}
      />
    </SearchContainer>
  );
};
